// Waitlist API Service for Pantria
// Sends waitlist signups via Cloudflare Pages Function

// Waitlist signup via serverless function
export const submitWaitlist = async (email, userType) => {
    try {
        const response = await fetch('/api/waitlist', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, userType })
        })

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Unknown server error' }))
            console.error('Waitlist API Error Details:', errorData)
            throw new Error(errorData.details || errorData.error || `Server error: ${response.status}`)
        }

        const result = await response.json()
        return result
    } catch (error) {
        console.error('Waitlist Error:', error)
        throw error
    }
}